import { isNil, isArray } from 'lodash';
import { queryParamHookFactory } from 'modules/taboola-common-frontend-modules/query-params';

const emptyFormEntityFields = [];

const deserializeFormEntityFields = selectedEntityFields => {
    if (isNil(selectedEntityFields)) {
        return emptyFormEntityFields;
    }

    try {
        const parsedValue = JSON.parse(selectedEntityFields);
        if (!isArray(parsedValue)) {
            return emptyFormEntityFields;
        }

        return parsedValue;
    } catch (e) {
        console.error('Failed to parse selectedEntityFields:', e);
        return emptyFormEntityFields;
    }
};

export const FORM_ENTITY_FIELDS = 'formEntityFields';

export const useFormEntityFields = queryParamHookFactory(FORM_ENTITY_FIELDS, {
    deserializer: deserializeFormEntityFields,
    defaultValue: emptyFormEntityFields,
});
